export function base64toFile(
  base64: string,
  filename: string,
  filetype: string
) {
  let bstr = atob(base64);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: filetype });
}
